export default "__VITE_ASSET__qfrs0Jr5__"